import { FaultRow } from 'components/tables/data/fault/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the device id.
 */
export default function DeviceIdColumn({ data: { deviceId } }: { data: FaultRow }) {
  return <P3Regular color="gray.8">{deviceId}</P3Regular>;
}
